import { GlSprintf } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import WorkItemTypeIcon from '/builds/gitlab/gitlab-ee/app/assets/javascripts/work_items/components/work_item_type_icon.vue?vue3';
export default {
    name: 'WorkItemRolledUpCountInfo',
    components: {
        GlSprintf,
        WorkItemTypeIcon
    },
    props: {
        filteredRollUpCountsByType: {
            type: Array,
            required: true
        }
    }
};
